const appConfig = {
    appId: "ledgerQore-2e05b8ac-c9f1-4a71-a586-d7dca71c399a",
    appName: "Ledger",
    site: 'ledger-qore',
    icon: "https://nsdstaticasset.blob.core.windows.net/assets/Qore_Brand_Icons/ledgerQoreAppIcon.png"
};

export default appConfig;
